import React, { Component } from "react";
import { callPlayer, getSDK } from "../utils.js";
const SDK_URL = "https://cdn.embed.ly/player-0.1.0.min.js";
const SDK_GLOBAL = "playerjs";
const MATCH_URL = /streamable\.com\/([a-z0-9]+)$/;
class Streamable extends Component {
  constructor() {
    super(...arguments);
    this.callPlayer = callPlayer;
    this.duration = null;
    this.currentTime = null;
    this.secondsLoaded = null;
    this.mute = () => {
      this.callPlayer("mute");
    };
    this.unmute = () => {
      this.callPlayer("unmute");
    };
    this.ref = (iframe) => {
      this.iframe = iframe;
    };
  }
  load(_url) {
    getSDK(SDK_URL, SDK_GLOBAL).then((playerjs) => {
      if (!this.iframe) return;
      this.player = new playerjs.Player(this.iframe);
      this.player.setLoop(this.props.loop);
      this.player.on("ready", this.props.onReady);
      this.player.on("play", this.props.onPlay);
      this.player.on("pause", this.props.onPause);
      this.player.on("seeked", this.props.onSeek);
      this.player.on("ended", this.props.onEnded);
      this.player.on("error", this.props.onError);
      this.player.on("timeupdate", ({ duration, seconds }) => {
        this.duration = duration;
        this.currentTime = seconds;
      });
      this.player.on("buffered", ({ percent }) => {
        if (this.duration) {
          this.secondsLoaded = this.duration * percent;
        }
      });
      if (this.props.muted) {
        this.player.mute();
      }
    }, this.props.onError);
  }
  play() {
    this.callPlayer("play");
  }
  pause() {
    this.callPlayer("pause");
  }
  stop() {
  }
  seekTo(seconds) {
    this.callPlayer("setCurrentTime", seconds);
  }
  setVolume(fraction) {
    this.callPlayer("setVolume", fraction * 100);
  }
  setLoop(loop) {
    this.callPlayer("setLoop", loop);
  }
  getDuration() {
    return this.duration;
  }
  getCurrentTime() {
    return this.currentTime;
  }
  getSecondsLoaded() {
    return this.secondsLoaded;
  }
  render() {
    const id = this.props.url.match(MATCH_URL)[1];
    const style = {
      width: "100%",
      height: "100%"
    };
    return (
      // oxlint-disable-next-line jsx-a11y/iframe-has-title
      /* @__PURE__ */ React.createElement(
        "iframe",
        {
          ref: this.ref,
          src: `https://streamable.com/o/${id}`,
          frameBorder: "0",
          scrolling: "no",
          style,
          allowFullScreen: true
        }
      )
    );
  }
}
Streamable.displayName = "Streamable";
Streamable.canPlay = (url) => MATCH_URL.test(url);
export {
  Streamable
};
//# sourceMappingURL=streamable.js.map
